import gql from 'graphql-tag';
import Client from "../actions/client";
import Cookie from "../actions/cookie";

const CommonAction = {
    /**
     * @purpose: fetch country list
     * @author: Arijit Deb Roy
     * @params: status: <string>
     * @return: <JSON>
     */
    listCountry(status='active') {
        const LIST_COUNTRY = gql`
                query listCountry($token: AccessToken!, $input: CountryListInput!){
                  listCountry(token: $token, input: $input){
                    code
                    status
                    message
                    data{
                      totalCount
                      countries{
                        countryId
                        name
                        dialCode
                        code
                        currencyId
                        otherJson
                        status
                        createdBy
                        updatedBy
                        createdAt
                        updatedAt
                      }
                    }
                  }
                }
            `;
        return Client.query({
            query: LIST_COUNTRY,
            variables: {
                input: {
                    status: status,
                },
                token: {
                    accessToken : "",
                    accessRole : 1
                }
            }
        });
    },

    /**
     * @purpose: fetch anonymous course list
     * @author: Arijit Deb Roy
     * @return: <JSON>
     */
    anonymousCourseList() {
      const LIST_COURSE = gql`
      query anonymousCourseList($input: UserDetailsInput!) {
        anonymousCourseList(input: $input) {
          code
          status
          message
          data{
            courseId
            courseName
            status
            courseDescription
          }
        }
      }
    `;
    return Client.query({
        query: LIST_COURSE,
        variables: {
            input: {
                excludeCourseIds: JSON.parse(process.env.NEXT_PUBLIC_EXCLUDE_COURSE_IDS),
            },
        }
    });
  },
    /**
     * @purpose: fetch anonymous User Exists or not
     * @author: Susanta Chakraborty
     * @param: inputObj<Object> { email: <string>}
     * @return: <JSON>
     */
    anonymousCheckUser(inputObj) {
      const CHECK_USER = gql`
        query anonymousCheckUser($input: anonymousCheckUserInput!) {
          anonymousCheckUser(input: $input) {
            code
            status
            message {
              status
            }
          }
        }
      `;
      return Client.query({
        query: CHECK_USER,
        variables: {
          input: {
            email: inputObj.email
          }
        }
      });
    },
    /**
     * @purpose: fetch orgHead & Agent Details using their Id
     * @author: Susanta Chakraborty
     * @return: <JSON>
     */
    fetchPartnerRefferalDeatails(agentId) {
      const REFFERAL_DETAILS = gql`
        query fetchPartnerRefferalDetails($token: AccessToken!,$input: PartnerRefferalDetails!){
          fetchPartnerRefferalDetails(token: $token, input:$input){
            code
            status
            message
            data {
              firstName
              lastName
              userFileId
              userFilePath
              email
              mobile
              agentDetailsId
              agentId
              referenceCode
              agentStatus
              countryId
              countryName
              currencyShortName
              currencySymbol
              createdAt
            }
          }
        }
      `;
      return Client.query({
        query: REFFERAL_DETAILS,
        variables: {
          token: {
            accessToken: Cookie.getCookie('_accessToken'),
            accessRole: atob(Cookie.getCookie('_accessRole'))
          },
          input: {
            agentId: agentId
          }
        }
      });
    },
    /**
     * @purpose: Post Call to invite Parent before sending mail
     * @author: Susanta Chakraborty
     * @param: inputObj { userId: <Int>, token: <String>}
     * @return: <JSON>
     */
    inviteParent(inputObj) {
      const INVITE_PARENT = gql`
        mutation inviteParent($token: AccessToken!, $input: InviteParentInput!){
          inviteParent(token:$token,input:$input){
            code
            status
            message
          }
        }
      `;
      return Client.mutate({
        mutation: INVITE_PARENT,
        variables: {
          token: {
            accessToken: Cookie.getCookie('_accessToken'),
            accessRole: atob(Cookie.getCookie('_accessRole'))
          },
          input: {
            userId: inputObj.userId,
            token: inputObj.token
          }
        }
      });
    },
};

export default CommonAction;
